// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dpSNj","fadeIn":"styles_fadeIn__8QhWN"};